import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@src/design-system/dialog';
import { Button } from '@src/design-system/button';

import { AddSquare } from 'iconsax-react';
import { InfiniteList } from '@src/design-system/molecules/infinite-list';
import customFieldApi from '@src/shared/features/custom-fields/services/custom-field-api';
import { CustomFieldAddDialog } from './custom-field-add-dialog';

import { CustomFieldItemActions } from './custom-field-item-actions';
import { CustomFieldItemIconTooltip } from './custom-field-item-icon-tooltip';
import { useTiclickTableContext } from '@src/design-system/molecules/ticlick-table/context/ticlick-table-context-hook';
import { useUserTypeCheck } from '@src/shared/hooks/use-user-type-check';

export const CustomFieldListDialog = () => {
  const { table } = useTiclickTableContext();
  const entity = table.options.meta?.identifyingData.customFieldEntityType;
  const isPartner = useUserTypeCheck('PARTNER');

  return (
    <>
      <DialogHeader>
        <DialogTitle>Custom Columns</DialogTitle>
      </DialogHeader>

      <DialogBody className='flex flex-col gap-6'>
        <InfiniteList
          props={{
            listContainerProps: {
              className: 'p-0 max-h-auto min-h-auto h-full',
              notFound: (
                <div className='flex py-8 justify-center items-center'>
                  <span className='text-center text-base text-gray-1000'>
                    No custom fields found.
                  </span>
                </div>
              ),
            },
            searchContainerProps: { className: 'p-0' },
          }}
          enableSearch
          fetchInfiniteData={customFieldApi.useFetchInfinite}
          query={{
            entity,
          }}
          renderItem={(item) => {
            return (
              <div className='flex items-center justify-between'>
                <div className='flex items-center text-gray-900 gap-2 text-sm'>
                  <CustomFieldItemIconTooltip customField={item} />
                  <span>{item.label}</span>
                </div>

                {!isPartner && <CustomFieldItemActions customField={item} />}
              </div>
            );
          }}
        />
      </DialogBody>

      {!isPartner && (
        <DialogFooter>
          <Dialog>
            <DialogTrigger asChild>
              <Button
                type='submit'
                className='w-full'
              >
                <AddSquare className='size-4' />
                Add new column
              </Button>
            </DialogTrigger>

            <DialogContent
              onCloseAutoFocus={(e) => e.preventDefault()}
              onOpenAutoFocus={(e) => e.preventDefault()}
              dialogOverlayProps={{
                className: 'bg-transparent',
              }}
            >
              <CustomFieldAddDialog />
            </DialogContent>
          </Dialog>
        </DialogFooter>
      )}
    </>
  );
};
